import React, { Component } from "react";
import Registration from "../Registration/Registration";

class ChangePasswordPage extends Component {
  render() {
    return <Registration actionType={"changePassword"} />;
  }
}

export default ChangePasswordPage;
